import React, { Component } from 'react';
import PropTypes from 'prop-types';

import './LeadGenRadioButton.scss';

export default class LeadGenRadioButton extends Component {
  static propTypes = {
    input: PropTypes.object.isRequired,
    options: PropTypes.array.isRequired,
    type: PropTypes.string,
    meta: PropTypes.object,
    label: PropTypes.string,
    isRequired: PropTypes.bool,
    color: PropTypes.string,
  };

  static setActiveRadioClass(itemValue, currentValue, isError) {
    const errorClass = isError ? 'lead-gen-radio-btn__custom-radio--error' : '';
    const activeClass =
      itemValue === currentValue
        ? 'lead-gen-radio-btn__custom-radio--active'
        : '';

    return `lead-gen-radio-btn__custom-radio ${activeClass} ${errorClass}`;
  }

  static setActiveColor(itemValue, currentValue, color) {
    if (color && itemValue === currentValue) {
      return { border: `6px solid ${color}` };
    }
  }

  renderRadioInput(isError) {
    const { input, options, type = 'radio', color } = this.props;

    return options.map((radioBtn) => {
      const inputId = `${String(input.name).replace(/[^a-zA-Z0-9_-]/g, '-')}-${
        radioBtn.value
      }`;

      return (
        <div className="lead-gen-radio-btn__item" key={radioBtn.value}>
          <label
            className="lead-gen-radio-btn__label"
            htmlFor={inputId}
            onClick={() => input.onChange(radioBtn.value)}
          >
            <input
              {...input}
              id={inputId}
              value={radioBtn.value}
              checked={radioBtn.value === input.value}
              type={type}
              onChange={() => input.onChange(radioBtn.value)}
              className="lead-gen-radio-btn__native-radio"
              data-test-lead-gen="lead-gen-radio-btn-native-radio"
            />
            <div
              style={LeadGenRadioButton.setActiveColor(
                radioBtn.value,
                input.value,
                color,
              )}
              className={LeadGenRadioButton.setActiveRadioClass(
                radioBtn.value,
                input.value,
                isError,
              )}
              data-test-lead-gen="lead-gen-radio-btn-custom-radio"
            />
            <div className="lead-gen-radio-btn__text">{radioBtn.label}</div>
          </label>
        </div>
      );
    });
  }

  render() {
    const { label, isRequired, meta: { error, touched } = {} } = this.props;
    const isError = error && touched;

    return (
      <div
        className="lead-gen-radio-btn"
        data-test-lead-gen="lead-gen-radio-btn"
      >
        <div className="lead-gen-radio-btn__header">
          <p
            className="lead-gen-radio-btn__title"
            data-test-lead-gen="lead-gen-radio-btn-title"
          >
            {label}
            {isRequired ? ' *' : ''}
          </p>
          {isError && (
            <div
              className="lead-gen-radio-btn__error"
              data-test-lead-gen="lead-gen-radio-btn-error"
            >
              {error}
            </div>
          )}
        </div>
        <div className="lead-gen-radio-btn__wrapper">
          {this.renderRadioInput(isError)}
        </div>
      </div>
    );
  }
}
